export type ReferenceTabRouteName =
  | "dictionary"
  | "composition"
  | "strokes"
  | "sentences"
  | "learningProgress";

export type ReferenceTabRoute = {
  key: ReferenceTabRouteName;
  name: ReferenceTabRouteName;
};

export function referenceTabTitle(routeName: ReferenceTabRouteName): string {
  switch (routeName) {
    case "dictionary": {
      return "Dictionary";
    }
    case "composition": {
      return "Compounds";
    }
    case "strokes": {
      return "Caligraphy";
    }
    case "sentences": {
      return "Sentences";
    }
    case "learningProgress": {
      return "Progress";
    }
  }
}

export function isInfoTabRouteNameInList(
  routeName: string,
  tabRouteList: readonly ReferenceTabRoute[],
): routeName is ReferenceTabRouteName {
  return tabRouteList.some((route) => route.name === routeName);
}

export function referenceTabIndex(
  tabRouteList: readonly ReferenceTabRoute[],
  routeName: ReferenceTabRouteName | undefined,
): number {
  if (routeName === undefined) {
    return 0;
  }
  const index = tabRouteList.findIndex((route) => route.name === routeName);
  return index === -1 ? 0 : index;
}
